import React from 'react';
const Footer = () => {
    return ( 
        <div className='footer'>
            <p>Made with ❤️ by Shakh Dev</p>
        </div> 
    );
}
 
export default Footer;